const categories = [
  {
    id: 1,
    category: "All",
  },
  {
    id: 2,
    category: "Easy",
  },
  {
    id: 3,
    category: "Medium",
  },
  {
    id: 4,
    category: "Difficult",
  },
];

export { categories };
